type NetworkInformation = { saveData?: boolean; effectiveType?: string };

export function isConstrainedNetwork(): boolean {
    const connection = (
        navigator as Navigator & { connection?: NetworkInformation }
    ).connection;
    if (!connection) return false;

    return (
        connection.saveData === true ||
        connection.effectiveType === "slow-2g" ||
        connection.effectiveType === "2g"
    );
}
